import React from 'react';
import Card from '@material-ui/core/Card';
import Grid, { GridProps } from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';

interface WizardCardProps extends GridProps {
  children: React.ReactNode;
}

const WizardCard = ({
  children,
  xs = 12,
  sm = 10,
  md = 8,
  lg = 6,
}: WizardCardProps) => (
  <Grid item xs={xs} sm={sm} md={md} lg={lg}>
    <Card>
      <CardContent>{children}</CardContent>
    </Card>
  </Grid>
);

export default WizardCard;
